import classNames from 'classnames';
import get from "lodash/get";
import React from 'react';
import AsyncSelect from 'react-select/async';
import { customStyles } from '../custom-select/custom-styles';
import { CustomInput } from '../custom-select/CustomInput';
import { CustomMenuList } from '../custom-select/CustomMenuList';
import { CustomOption } from '../custom-select/CustomOption';
import { locationInputPropTypes } from '../location-input-prop-types';
import { useLocationInput } from '../use-location-input';
import {useSearch} from "../../SearchForm/use-search";

export const DesktopLocationInput = (props) => {
  const { intl } = useSearch();
  const placeholder = intl.formatMessage({
    id: 'shared_components.location-input.async-select-placeholder',
    defaultMessage: 'Enter a city or address'
  });

  const {
    fetchSuggestions,
    isFocused,
    defaultOptions,
    inputDisplay,
    value,
    formActive,
    isOptionError,
    onChange,
    inputChange,
    handleInputFocus,
    handleInputBlur,
    handleContainerFocus
  } = useLocationInput(props);

  const getInputColorClass = () => {
    let colorClass = '';
    if (formActive && !isFocused) {
      colorClass += 'text-gray-500';
    } else {
      colorClass += value ? 'text-gray-900' : 'text-gray-600';
    }
    return colorClass;
  };
  return (
    <div
      className="flex column location_input_wrap"
      role="button"
      tabIndex="0"
      onFocus={handleContainerFocus}
    >
      <label
        htmlFor='location-input'
        className={classNames(
          'text-xs no-bottom-margin',
          `${formActive && !isFocused ? 'text-gray-500' : 'text-gray-600'}`
        )}
      >
        {
          intl.formatMessage({
            id: 'shared_components.activity-input.location-input-label',
            defaultMessage: 'Where?'
          })
        }
      </label>
      {!isFocused ? (
        <button
          className={classNames(
            'readonly_location_input btn-clear sans-serif',
            getInputColorClass()
          )}
          onClick={(e) => e.preventDefault()}
        >
          {inputDisplay || placeholder}
        </button>
      ) : (
        <AsyncSelect
          id='location-input'
          inputValue={inputDisplay}
          autoFocus={true}
          controlShouldRenderValue={false}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          placeholder={placeholder}
          isClearable
          instanceId='location-input'
          onChange={onChange}
          onInputChange={inputChange}
          openMenuOnFocus
          defaultOptions={defaultOptions}
          loadOptions={fetchSuggestions}
          noOptionsMessage={() => null}
          getOptionValue={(suggestion) => suggestion.value}
          styles={customStyles(isFocused, formActive, false)}
          minMenuHeight="1000"
          components={{
            MenuList: (props) => CustomMenuList(props, isOptionError),
            Option: CustomOption,
            LoadingIndicator: () => null,
            IndicatorsContainer: () => null,
            Input: CustomInput
          }}
        />
      )}
    </div>
  );
};

DesktopLocationInput.propTypes = locationInputPropTypes;
